<template>
  <div
    class="flex flex-col origin-top-right transform transition max-w-lg bg-white shadow-lg fixed top-44 bottom-5 max-h-96 right-3 left-3 z-50 text-sm"
  >
    <div class="absolute inset-0 rounded-2xl overflow-hidden">
      <span
        class="absolute inset-0 bg-gradient-to-b from-blue-500 to-purple-600"
      ></span>
      <span class="absolute inset-1 bg-white rounded-xl"></span>
    </div>
    <div class="relative z-10 pt-7 px-7 mb-2 flex">
      <h4 class="font-bold text-base">{{ title }}</h4>
      <button
        @click="$emit('click')"
        aria-label="Close Summary"
        class="ml-auto hover:text-gray-700 text-gray-500 w-7 transition-all"
      >
        <i v-icon:close-x></i>
      </button>
    </div>
    <div class="h-1 flex-grow px-7 pb-7">
      <div
        class="relative text-justify leading-relaxed h-full pr-2 overflow-y-auto overflow-x-hidden"
      >
        <span v-html="safeHtml"></span>
      </div>
    </div>
  </div>
</template>

<script>
import showdown from "showdown";

export default {
  name: "VSummaryFloat",
  props: {
    content: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      converter: new showdown.Converter({
        parseHtml: false,
        simpleLineBreaks: true,
        noHeaderId: true,
        ghCompatibleHeaderId: false,
      }),
    };
  },
  computed: {
    safeHtml() {
      const plainHtml = this.converter.makeHtml(this.content);
      return plainHtml
        .replace(/<\/p>\s*<p>/g, "\n\n")
        .replace(/<br\s*\/?>/g, "\n")
        .replace(/<\/?[^>]+(>|$)/g, "")
        .replace(/\n{3,}/g, "\n\n")
        .replace(/\n\n/g, "</p><p>")
        .replace(/\n/g, "<br>")
        .replace(/^(.+)$/, "<p>$1</p>")
        .trim();
    },
  },
};
</script>
